<div class="container-xxl container-p-y d-flex justify-content-center align-items-center vh-100">
    <div class="misc-wrapper">
        <h2 class="mb-2 mx-2">Page introuvable</h2>
        <p class="mb-4 mx-2">la page demandée n'est pas disponible</p>
        <div>
            <button (click)="retourner()" class="btn btn-primary">Retourner à la page précédente</button>
            <a class="ms-2" [routerLink]="['/']">se connecter</a>
        </div>
    </div>
</div>